var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-card',{attrs:{"title":_vm.title}},_vm._l((_vm.data),function(item,index){return _c('custom-descriptions',{key:index,attrs:{"need-bordered":_vm.needBordered,"data":item,"field-list":_vm.fieldList,"column":_vm.column}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }